import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent {

  @Input() message?: string;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/information/information.component.ts